'use client';

import { ChatTweet } from '@/components/chat/ChatTweet';
import type { SearchTimelineToolResultData } from '../types';
import { pluralize } from '../utils';
import { EmptyResult } from './GenericObjectResult';

export interface SearchTimelineResultProperties {
  query: string | null;
  result: SearchTimelineToolResultData;
}

export function SearchTimelineResult({ result, query }: SearchTimelineResultProperties) {
  if (result.tweets.length === 0) {
    const queryLabel = query ? `“${query}”` : 'your request';
    return <EmptyResult message={`No tweets matched ${queryLabel} in your recent timeline.`} />;
  }

  const headerText = query
    ? `Showing ${pluralize(result.tweets.length, 'tweet')} found for “${query}”.`
    : `Showing ${pluralize(result.tweets.length, 'tweet')} from your timeline.`;

  return (
    <div className="space-y-2 text-sm">
      <div className="text-xs text-muted-foreground">{headerText}</div>
      <div className="space-y-3">
        {result.tweets.map((tweet) => (
          <ChatTweet key={tweet.id} tweetId={tweet.id} />
        ))}
      </div>
    </div>
  );
}
